import { render } from "./SystemNotice.vue?vue&type=template&id=894413a0&scoped=true"
import script from "./SystemNotice.vue?vue&type=script&lang=js"
export * from "./SystemNotice.vue?vue&type=script&lang=js"

import "./SystemNotice.vue?vue&type=style&index=0&id=894413a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894413a0"]])

export default __exports__